export const getMyApps = (obj) => obj?.mainLinks?.myApps;
export const getResources = (obj) => obj?.mainLinks?.resources;
export const getBuildAppDoc = (obj) => obj?.mainLinks?.buildAppDoc;
export const getApiAndSdk = (obj) => obj?.mainLinks?.apiAndSdk;
export const getAppTemplate = (obj) => obj?.mainLinks?.appTemplates;
export const getApiReference = (obj) => obj?.mainLinks?.apiReference;
export const getSupport = (obj) => obj?.mainLinks?.support;
export const getAppMarket = (obj) => obj?.mainLinks?.appMarket;
//# sourceMappingURL=selectors.js.map